export default "__VITE_ASSET__DGVgDygQ__"